import React from 'react'
import Modal from '@/src/components/modal/Modal'

interface ModalProps {
  title: string
  text: string
  isOpen: boolean
  handleOpen: () => void
  handleClose: () => void
}

const TextModal = ({ isOpen, handleOpen, handleClose, text, title }: ModalProps) => {
  return (
    <Modal title={title} isOpen={isOpen} handleOpen={handleOpen} handleClose={handleClose}>
      <span className="text-primary-gray font-medium whitespace-pre-line">{text}</span>
    </Modal>
  )
}

export default TextModal
